export default __webpack_public_path__ + "static/media/tokens icon 1.e0f02ec1.svg";